import { render } from "./np-multiselect.vue?vue&type=template&id=048821ba"
import script from "./np-multiselect.vue?vue&type=script&lang=js"
export * from "./np-multiselect.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__